require('../sass/style.scss');



//////////////////
// WEBPACK FOOTER
// ./build/css.js
// module id = 722
// module chunks = 0